import React from 'react';
import { CenterWrapper } from './styles';
interface CenterPropsI {
    children: React.ReactNode
}
export default function Center({children}: CenterPropsI) {
    return <CenterWrapper>{children}</CenterWrapper>;
}